import { IconProps } from '@/types/icon';

export function IconeCartao(props: IconProps) {
  const { size } = props;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="cartao"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...props}
    >
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <path
        d="M20 3H4C2.89 3 2.01 3.89 2.01 5L2 17C2 18.11 2.89 19 4 19H9V17H4V11H22V5C22 3.89 21.11 3 20 3ZM20 7H4V5H20V7ZM14.93 18.17L12.1 15.34L10.69 16.75L14.93 21L22 13.93L20.59 12.52L14.93 18.17Z"
        fill="currentColor"
      />
    </svg>
  );
}
